import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { EAccount } from 'utils/constants/store/query-keys';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { getAccountJsonQuery } from 'services/account-settings';
import { setAccountParams } from 'store/actions';
import { getAccountParams } from 'store/selectors/app-data';

export const useFetchAccountParams = () => {
  const accountJsonQuery = getAccountJsonQuery;
  const accountParamsData = useSelector(getAccountParams);
  const dispatch = useDispatch();
  const { data, error, isLoading, isSuccess } = useQuery({
    queryKey: [EAccount['AccountParams']],
    queryFn: () => accountJsonQuery(SpringConfigs.ACCOUNT_PARAMS),
    retry: false
  });

  useEffect(() => {
    if (isSuccess && data) {
      dispatch(setAccountParams(data));
    }
  }, [isSuccess, data]);

  const accountParams = useMemo(() => {
    if (error || !data) {
      return accountParamsData;
    }

    if (SpringConfigs.CYPRUS_ACCOUNT_TYPE) {
      return {
        ...data,
        'months-7': '1',
        'months-8': '1',
        'months-9': '1',
        'months-10': '1',
        'months-11': '1',
        'months-timeout-hours-72': '1'
      };
    }

    return data;
  }, [data, error, accountParamsData]);

  return {
    accountParams,
    error,
    isLoading
  };
};
